export default __webpack_public_path__ + "static/media/group-option-hairmale-unselected.ee6d3ff3.svg";